"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M8 9c0-.485.3165-1.2334 1.052-1.893C9.7612 6.471 10.7778 6 12 6c2.3682 0 4 1.9461 4 4 0 2.9597-1.3252 3.4336-2.8 5.4-.6303.8404-1.0706 1.801-1.6889 2.6478-.487.667-.9065.9522-1.5111.9522-.9896 0-2-.9825-2-2H6c0 2.1055 1.9227 4 4 4 1.5204 0 2.4634-.8648 3.1264-1.7728.6132-.8398 1.0495-1.795 1.6736-2.6272 1.0752-1.4336 3.2-2.7597 3.2-6.6 0-3.0461-2.4182-6-6-6-1.7528 0-3.2362.679-4.2833 1.618C6.696 6.5334 6 7.785 6 9h2z"
  }), _react.default.createElement("path", {
    d: "M11.1102 9.795a1.1177 1.1177 0 0 1 1.4103.1397l.7724.7724 1.4142-1.4142-.7724-.7724c-1.0509-1.0509-2.6974-1.2139-3.9339-.3895-1.3083.8721-1.7623 2.582-1.0592 3.9883.3497.6993.4527 1.5655-.3888 1.9863l.8944 1.7888c1.8288-.9144 2.1259-2.9842 1.2833-4.6695a1.1177 1.1177 0 0 1 .3797-1.4298z"
  })];
};

exports.default = _default;